import React, { useEffect } from "react";
import { DialogActions } from "@material-ui/core";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../../partials/content/Forms/AppForm";
import JourneyEditFormContent from "./journeyEditFormContent";
import { updateSalesJourney } from "../../../../../../services/crm/salesJourney";
import store from "../../../../../../store/store";
import { setObject } from "../../../../../../utils/utils";
import { useGlobalData } from "../../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
const journeySchema = yup.object().shape({
  ID: yup.number(),
  title: yup
    .string()
    .required("Sales Journey Name is required")
    .max(255, "Sales Journey Name maximum characters is 255"),
  planStartDate: yup
    .date()
    .required("Plan Start Date is required")
    .max(
      yup.ref("planEndDate"),
      "Plan Start Date must be less equal to Plan End Date"
    ),
  planEndDate: yup
    .date()
    .required("Plan End Date is required")
    .min(
      yup.ref("planStartDate"),
      "Plan End Date must be greater equal to Plan Start Date"
    ),
  description: yup.string(),
  salesName: yup.string().required("Assigned To is required"),
});
function JourneyEditForm({
  journey = {
    ID: 0,
    title: "",
    planStartDate: DateTime.now().startOf("day"),
    planEndDate: DateTime.now().endOf("day"),
    salesID: 0,
    salesName: "",
    description: "",
  },
  onConfirmSave,
  onCloseDialog,
}) {
  const { socket } = useGlobalData();
  useEffect(() => {
    const { auth } = store.getState();

    if (journey && journey.ID > 0) {
      setObject(socket, "lock", journey.ID, "SLJO", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (journey && journey.ID > 0) {
        setObject(socket, "release", journey.ID, "SLJO", auth.user);
      }
    };
  }, [journey]);
  return (
    <AppForm
      initialValues={journey}
      validationSchema={journeySchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Sales Journey ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              updateSalesJourney(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
      headSubmitButton={false}
    >
      <JourneyEditFormContent />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={onCloseDialog}
        >
          <i className="fas fa-window-close"></i>
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default JourneyEditForm;
